import axios from "axios";

const baseUrl = `${process.env.REACT_APP_QCX_API_BASE_URL}/${process.env.REACT_APP_QCX_API_CATALOGO_PRODUTOS_ENDPOINT}/relatorio-mercadorias`;

const generateRelatCatalogoOperadores = async (
  token: string,
  tenantId: number,
  clienteIds: string[],
  partnumber: string,
  empresaEstrangeiraIds: string[],
  codigoIntegracao: string,
  dataInicio?: string,
  dataFim?: string
): Promise<string | null> => {
  const params = new URLSearchParams();

  if (clienteIds.length > 0) {
    params.set("clienteIds", clienteIds.join(","));
  }
  if (partnumber && partnumber.trim()) {
    params.set("partnumber", partnumber.trim());
  }
  if (empresaEstrangeiraIds.length > 0) {
    params.set("empresaEstrangeiraIds", empresaEstrangeiraIds.join(","));
  }
  if (codigoIntegracao && codigoIntegracao.trim()) {
    params.set("codigoIntegracao", codigoIntegracao.trim());
  }
  if (dataInicio && dataInicio.trim()) {
    params.set("dataInicio", `${dataInicio.trim()}T00:00:00`);
  }
  if (dataFim && dataFim.trim()) {
    params.set("dataFim", `${dataFim.trim()}T23:59:59`);
  }

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: tenantId,
      },
      responseType: "blob",
    });

    if (response.status === 200) {
      const file = new File([response.data], "relacao_catalogo_operadores.xlsx", {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      a.click();
      return null;
    }

    return await response.data.text();
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      try {
        return await error.response.data.text();
      } catch {
        return "Erro inesperado ao gerar relatório.";
      }
    }
    return "Erro inesperado ao gerar relatório.";
  }
};

export default generateRelatCatalogoOperadores;
